import React, { Component } from "react"
import { TableDigitalizados } from "./"
import Layout from "../../Layout"
import Moment from "moment"
import { Loading, HttpError } from "../../../components"
import Util from "../../../Util"
import * as ApiHelper from "../../../ApiHelper"
export default class Digitalizados extends Component {
  constructor() {
    super()
    this.getContratosDigitalizados = this.getContratosDigitalizados.bind(this)
    this.filter = this.filter.bind(this)
    this.state = {
      contratosDigitalizados: [],
      initialContratosDigitalizados: [],
      showTable: false
    }
  }
  componentWillMount() {
    this.getContratosDigitalizados()
  }
  getContratosDigitalizados() {
    ApiHelper.getContratosDigitalizados(
      this.props.match.params.id,
      (contratosDigitalizados, error) => {
        if (contratosDigitalizados) {
          this.setState({
            contratosDigitalizados: contratosDigitalizados,
            initialContratosDigitalizados: contratosDigitalizados,
            showTable: true
          })
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialContratosDigitalizados.filter(contrato => {
      return (
        Util.getLastPathComponent(contrato.nome)
          .toLowerCase()
          .search(searchText) !== -1 ||
        Moment(contrato.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1
      )
    })
    this.setState({
      contratosDigitalizados: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Contratos">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Contratos">
        {this.state.showTable ? (
          <TableDigitalizados
            filter={this.filter}
            onDelete={this.getContratosDigitalizados}
            sizeClass=""
            title="Contratos digitalizados"
            subtitle="Listagem de todos os contratos digitalizados"
            backgroundColor="as-blue"
            rows={this.state.contratosDigitalizados}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/contratos/digitalizados/Digitalizados.js